import type { SVGProps } from 'react'

/**
 * Official black Apple mark for SSO buttons and profile rows. The viewBox is cropped to the mark so `size` is its
 * rendered height and the mark is centered, matching the other provider logos.
 */
export function AppleLogo({ size = 20, ...props }: SVGProps<SVGSVGElement> & { size?: number }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="3.62 1.39 19.95 19.95"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            <path
                fill="#000000"
                d="M16.365 1.43c0 1.14-.46 2.1-1.08 2.78-.65.74-1.72 1.3-2.68 1.22-.1-1.1.47-2.2 1.08-2.87.69-.76 1.85-1.32 2.68-1.13zM20.5 17.16c-.33.76-.72 1.46-1.18 2.1-.71.98-1.6 2.07-2.73 2.08-1 .01-1.3-.64-2.7-.63-1.4.01-1.73.64-2.73.63-1.13-.01-1.98-1.03-2.69-2.01-1.86-2.6-3.3-7.36-1.38-10.56.93-1.57 2.6-2.56 4.3-2.59 1.24-.02 2.03.65 3.03.65 1 0 1.65-.65 3.03-.63 1.01.02 2.53.52 3.47 1.97-1.6.97-2.24 2.78-2.17 4.3.07 1.52.92 2.88 2.25 3.69-.14.34-.29.67-.46 1z"
            />
        </svg>
    )
}
